import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import URI from 'urijs'
import { get } from 'lodash-es'

import { useWebinarColors } from '../../../Designs/blocs/useWebinarColors'
import { useRoomDesign } from '../../../Designs/blocs/useRoomDesign'

import './VideoPlayerComponent.scss'

const getObjectURL = (object, objectType, customOptions = {}) => {
  const baseURL = new URI('/v.ihtml/player.html')
  const defaultOptions = {
    token: object.token,
    showDescriptions: 0,
    source: 'admin',
    autoPlay: 0,
  }

  if (objectType === 'live') {
    defaultOptions.live_id = object.live_id
  } else {
    defaultOptions.photo_id = object.photo_id
  }

  if (customOptions.mutedAutoPlay) {
    delete defaultOptions.autoPlay
  }

  baseURL.query({
    ...defaultOptions,
    ...customOptions,
  })

  return baseURL.toString()
}

const VideoPlayerComponent = ({ object, objectType, options, iframeRef }) => {
  const src = getObjectURL(object, objectType, options)
  const { background } = useWebinarColors()
  const roomDesign = useRoomDesign()

  const handlePlayerLoad = useCallback(
    (event) => {
      const iframeElement = event.target
      iframeElement.contentDocument.body.style.setProperty(
        '--player-background-color',
        background.color
      )
    },
    [background.color]
  )

  return (
    <div className="video-player-component">
      <iframe
        id="videoplayer"
        ref={iframeRef}
        src={src}
        frameBorder="0"
        scrolling="no"
        allowFullScreen
        title={get(object, 'title', 'Video Player')}
        onLoad={handlePlayerLoad}
        style={{
          borderRadius: `${roomDesign?.style.radius}px`,
        }}
      />
    </div>
  )
}

VideoPlayerComponent.propTypes = {
  object: PropTypes.object,
  objectType: PropTypes.oneOf(['live', 'photo']),
  options: PropTypes.object,
  iframeRef: PropTypes.object,
}

export default VideoPlayerComponent
